const _ = require("lodash");
const Storage = require("../util/Storage");
const moment = require("moment");

// Time identifier appended into session storage so that we can differentiate logs between different tabs.
const tabID = Date.now();

const isStorageEnabled = function() {
	try {
		return _.get(global.window, "sessionStorage") && !Storage.isDisabled();
	} catch (ex) {
		return false;
	}
};

const getLog = function() {
	if (isStorageEnabled()) {
		try {
			let sessionLog = global.window.sessionStorage.getItem("soundsLog");
			let localLog = Storage.getStorage().getItem("soundsLog");
			sessionLog = sessionLog ? JSON.parse(sessionLog).slice(-500) : [];
			localLog = localLog ? JSON.parse(localLog).slice(-500) : [];
			return {
				sessionLog,
				localLog,
			};
		} catch (ex) {
			return {
				sessionLog: ["ERROR_OBTAINING_STORAGE"],
				localLog: ["ERROR_OBTAINING_STORAGE"],
			};
		}
	}
	return {
		sessionLog: [],
		localLog: [],
	};
};

const logItem = function(message, data) {
	if (isStorageEnabled()) {
		try {
			const parsedLog = getLog();
			const logObject = _.extend(
				{
					message,
					tabID,
					loggedAt: moment.utc(),
				},
				data
			);
			// Add to sessionStorage log
			parsedLog.sessionLog.push(logObject);
			sessionStorage.setItem("soundsLog", JSON.stringify(parsedLog.sessionLog));
			// Add to localStorage log
			parsedLog.localLog.push(logObject);
			Storage.getStorage().setItem(
				"soundsLog",
				JSON.stringify(parsedLog.localLog)
			);
		} catch (ex) {
			// If there was an error accessing storage, we just don't log anything.
		}
	}
};

module.exports = {
	getLog,
	logItem,
};
